export var defaultColor = '#D4D4C8';
export var signColor = '#808080';
export var elementColor = '#569CD6';
export var attributeNameColor = '#9CDCFD';
export var attributeValueColor = '#CE9178';
